import type { AppletLayoutProps } from '../../../applets';
import CanvasLayout from '../../CanvasLayout';

export default function CartographerLayout({
  children,
  title,
}: AppletLayoutProps) {
  return <CanvasLayout title={title}>{children}</CanvasLayout>;
}
